// extracted by mini-css-extract-plugin
module.exports = {"height":"Illustrations-IllustrationPlaceholder-height-5aa66a6d"};